<div *ngIf="!busy" class="tripadvisor-reviews">
  <div class="block-content">
    <div class="resume-column">
      <div class="head">
        <mb-reviews-rating
          rating="{{ tripadvisorReviews.rating > 4 ? tripadvisorReviews.rating : '' }}"
        >
          <mb-reviews-evaluation>
            {{ tripadvisorReviews.ratingLabel }}</mb-reviews-evaluation
          >
          <mb-reviews-detail *ngIf="tripadvisorReviews.num_reviews">
            {{ tripadvisorReviews.num_reviews }} opiniones
          </mb-reviews-detail>
        </mb-reviews-rating>
        <img src="{{ tripadvisorReviews.rating_image_url }}" />
      </div>
      <ng-container *ngFor="let rating of tripadvisorReviews.ratings">
        <mb-bar-rating [title]="rating.name" [rating]="rating.value"></mb-bar-rating>
      </ng-container>
    </div>
    <div class="reviews-column">
      <h2 class="name">Opiniones</h2>
      <div class="reviews">
        <div *ngFor="let review of tripadvisorReviews.reviews" class="review">
          <mb-comments [review]="review"></mb-comments>
        </div>
      </div>
    </div>
  </div>
</div>
